export const validIncludeUrl = (
  rule: any,
  value: string,
  cb: (msg?: string) => void,
) => {
  if (!value) {
    cb()
    return
  }

  // メールアドレスも禁止
  if (value.includes("@")) {
    cb("文章にメールアドレスを含めることはできません")
    return
  }

  if (value.includes("http") || value.includes("https")) {
    cb("文章に URL を含めることはできません")
    return
  }

  cb()
}
